<template>
    <AccountLayout :loading="0" :isError=false>
        <div>
            <v-container id="condition-box">
                <v-row class="d-flex justify-center">
                    <v-col class="pl-0 pr-0" cols="12" sm="auto" md="auto" style="display: flex; z-index: 1;">
                        <v-card max-width="800" style="border-radius: 30px 30px 30px 30px;" elevation="0">
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-row class="mx-6">
                                        <v-col cols="12" sm="12" md="12" class="pb-0">
                                            <div class="mt-7 prompt-title-500" style="
                                                    color: #255d98;
                                                    font-weight: 400;
                                                    text-align: left;
                                                ">
                                                {{ $t('message.policyPage.header.h1') }}
                                            </div>
                                            <v-divider class="mt-3" style="
                                                    border: 2px solid #ff9800;
                                                    margin:14px 0px;
                                                "></v-divider>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12" class="sarabun-18 pt-0">
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title1') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h1')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.title.t1') }}
                                            </span>
                                            <p style="font-size: 15px; margin-top: 1rem;"
                                                v-html="$t('message.policyPage.detail.h2')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title2') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h3')"></p>
                                            <p style="font-size: 15px;" class="my-5"
                                                v-html="$t('message.policyPage.detail.h4')"></p>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h5')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.title.t3') }}
                                            </span>
                                            <p style="font-size: 15px; margin-top: 1rem;"
                                                v-html="$t('message.policyPage.detail.h6')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.title.t2') }}
                                            </span>
                                            <p style="font-size: 15px; margin-top: 1rem;"
                                                v-html="$t('message.policyPage.detail.h7')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.title.t4') }}
                                            </span>
                                            <p style="font-size: 15px; margin-top: 1rem;"
                                                v-html="$t('message.policyPage.detail.h8')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title3') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h9')"></p>
                                            <p style="font-size: 15px;" class="my-5"
                                                v-html="$t('message.policyPage.detail.h10')"></p>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h11')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title4') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h12')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title5') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h13')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title6') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h14')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title7') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h15')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title8') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h16')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title9') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h17')"></p>
                                            <p style="font-size: 15px;" class="mt-5"
                                                v-html="$t('message.policyPage.detail.h18')"></p>
                                            <br />
                                            <span style="font-weight: 600;">
                                                {{ $t('message.policyPage.detail.title10') }}
                                            </span>
                                            <v-divider class="my-3"></v-divider>
                                            <p style="font-size: 15px;" v-html="$t('message.policyPage.detail.h19')"></p>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div id="orange-tab"></div>
        </div>
    </AccountLayout>
</template>
  
<script>
import AccountLayout from "@/components/common/AccountLayout";

export default {
    name: "PolicyComp",
    components: { AccountLayout },
    data: () => ({}),
    methods: {
        // Use this to convert i18n content that contain html tag to html format
        convertTextToHtml(content) {
            var str = content;
            return str;
        }
    },
    isError: true
};
</script>